import { render, staticRenderFns } from "./month-sessions-list.vue?vue&type=template&id=1f673f6c&lang=pug&"
import script from "./month-sessions-list.vue?vue&type=script&lang=js&"
export * from "./month-sessions-list.vue?vue&type=script&lang=js&"
import style0 from "./month-sessions-list.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports